<div id="login-dashboard" class="page-layout carded fullwidth h-100-p">

    <!-- TOP BACKGROUND -->
    <div class="top-bg"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" fxFlex>

        <!-- HEADER -->
        <div class="header" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">
            <!-- PAGE TITLE -->
            <div class="logo my-12 m-sm-0" fxLayout="column" fxLayoutAlign="center start">
                <div id="txtContentTitle" class="logo-text h1">Login Dashboard</div>
            </div>
            <!-- / PAGE TITLE -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div #content class="content-card mat-white-bg p-24">
            <div id="divTileView" class="divEmployeeLogin">
                <div class="EmployeePanel">
                    <div style="width:100%; overflow-y: auto;">
                        <dx-button *ngFor="let data of employees" (click)="EmployeeClicked(data.EmployeeId)"
                            [id]="'btnLogin'+data.EmployeeId" class="EmployeeButton"
                            [ngClass]="{'EmployeeButtonSelected' : data.Selected}">
                            <div style="display: flex; flex-direction: column; margin-top:40px;">
                                <ngx-avatars [name]="data.FullName" size="100" round="false" cornerRadius="5"></ngx-avatars>                                                            
                                <div class="EmployeeName">
                                    <div>{{data.FirstName}}</div>
                                    <div>{{data.LastName}}</div>
                                </div>
                            </div>
                        </dx-button>
                    </div>
                </div>
                <div class="PinEntryPanel pin">
                    <input #pinEntry type="number" class="PinNumber dx-textbox dx-texteditor dx-editor-outlined"
                        oninput="this.value=this.value.slice(0,4)" (keydown)="pinInputChanged($event)" min="0"
                        max="9999">
                    <div>
                        <dx-button id="pin7" class="NumberPadButton" (click)="btnPressNumber('7')">7</dx-button>
                        <dx-button id="pin8" class="NumberPadButton" (click)="btnPressNumber('8')">8</dx-button>
                        <dx-button id="pin9" class="NumberPadButton" (click)="btnPressNumber('9')">9</dx-button>
                    </div>
                    <div>
                        <dx-button id="pin4" class="NumberPadButton" (click)="btnPressNumber('4')">4</dx-button>
                        <dx-button id="pin5" class="NumberPadButton" (click)="btnPressNumber('5')">5</dx-button>
                        <dx-button id="pin6" class="NumberPadButton" (click)="btnPressNumber('6')">6</dx-button>
                    </div>
                    <div>
                        <dx-button id="pin1" class="NumberPadButton" (click)="btnPressNumber('1')">1</dx-button>
                        <dx-button id="pin2" class="NumberPadButton" (click)="btnPressNumber('2')">2</dx-button>
                        <dx-button id="pin3" class="NumberPadButton" (click)="btnPressNumber('3')">3</dx-button>
                    </div>
                    <div>
                        <dx-button id="pinClear" class="NumberPadButton" (click)="btnClear()">
                            <span class="material-icons">clear</span>
                        </dx-button>
                        <dx-button id="pin0" class="NumberPadButton" (click)="btnPressNumber('0')">0</dx-button>
                        <dx-button id="pinBack" class="NumberPadButton" (click)="btnBackSpace()">
                            <span class="material-icons">backspace</span>
                        </dx-button>
                    </div>
                    <div>
                        <dx-button id="pinLogin" class="LogButton" [disabled]="!btnLoginEnabled"
                            (click)="btnLogInClicked()" title="Check In to Active Salon">
                            Check In
                        </dx-button>
                    </div>
                    <div [hidden]="!ShowInvalidPinMessage" class="InvalidPinMsg">
                        PIN not valid for selected employee
                    </div>
                    <div style="margin-top: 36px;">
                        <dx-button id="pinShutdown" class="ShutdownButton" [title]="ShutdownTitle"
                             (click)="btnShutdownClicked()">
                            Logout
                        </dx-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CENTER -->
    <app-terminal-selection (CloseDlg)="OnCloseTerminalDlg($event)"></app-terminal-selection>
    <app-open-till (CloseDlg)="OnCloseOpenTillDlg($event)"></app-open-till>
</div>